import type { FaireProductEntity } from "../../entity_types/product";

export const p_hm44x2pgpm: FaireProductEntity = {
  token: "p_hm44x2pgpm",
  type: "product",
  name: "Happy Birthday Folk Floral Greeting Card",
  brandToken: "b_dfu92850",
  brandName: "Pippi Post",
  imageUrl:
    "https://cdn.faire.com/fastly/3b42a099bb7cca062f3c486c8fd8d40a01790871467b9368c016f5c355e79fb9.jpeg",
  galleryImageUrls: [],
  priceDollars: 4.13,
  description:
    'Celebrate birthdays with a touch of whimsical charm with our Happy Birthday Folk Floral Greeting Card! Whether it\'s for a friend, family member, or colleague, let this card bloom with joy and bring smiles to their face. \n\n•Size: A2, 5.5" x 4.25" \n•Features: Blank interior and coordinating envelope\n•Sentiment: Happy Birthday',
  tags: [],
  msrpDollars: 8.27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:12:01.123Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
